import BigButton from '@/Components/BigButton/BigButton'
import { usePlan } from '@/Hooks/UsePlan'
import useTranslation from '@/Hooks/UseTranslation'
import ProjectsActions from '@/Redux/Actions/ProjectsActions'
import ProjectsService from '@/Services/ProjectsService'
import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'

const ArchivedProjects = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    plan,
    tooManyArchivedProjects,
    showTooManyProjectsModal,
    showTooManyArchivedProjectsModal,
  } = usePlan()

  const projects = useSelector((state: any) => state.ProjectsReducer.data)
  const loadResultStatus = useSelector((state: any) => state.ProjectsReducer.loadResultStatus)
  const archivedProjects = projects?.archived || []

  const handleRestore = async (projectId: string) => {
    if (!plan.can('create', 'Project')) {
      showTooManyProjectsModal(t('HOME:TooManyActiveProjects-title'))
      return
    }

    try {
      await ProjectsService.restoreProject(projectId)
      await dispatch(ProjectsActions.getResultAction())
    } catch (error) {
      console.error('Error restaurando proyecto:', error)
    }
  }

  const handleDelete = async (projectId: string) => {
    const result = await Swal.fire({
      title: t('HOME:DeleteProject-title'),
      text: t('HOME:DeleteProject-content'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: t('HOME:DeleteProject-cancel'),
      confirmButtonText: t('HOME:DeleteProject-accept'),
      width: '500px',
    })

    if (result.isConfirmed) {
      await dispatch(ProjectsActions.deleteAction(projectId))
      await dispatch(ProjectsActions.getResultAction())
    }
  }

  useEffect(() => {
    if (loadResultStatus === 'none') {
      dispatch(ProjectsActions.getResultAction())
    }
  }, [dispatch, loadResultStatus])

  useEffect(() => {
    if (tooManyArchivedProjects) {
      showTooManyArchivedProjectsModal(t('HOME:TooManyArchivedProjects-title'))
    }
  }, [tooManyArchivedProjects])

  if (archivedProjects.length === 0) {
    return (
      <div className="pl4-home-empty">
        <div className="pl4-home-empty__icon"><i className="fas fa-archive" /></div>
        <strong>No tienes proyectos archivados</strong>
        <span>Los proyectos que archives aparecerán aquí.</span>
      </div>
    )
  }

  return (
    <Row className="mb-4 pl4-project-grid">
      {archivedProjects.map((project: any) => (
        <Col key={project._id} xl={3} lg={4} md={6} className="mb-3">
          <BigButton
            icon="fas fa-archive"
            text={project.shortName || project.name || 'Proyecto'}
            title={project.name}
            description={project.address}
            iconColor="#697089"
            iconBg="#eef0f6"
            altMenu={[
              {
                icon: <i className="fas fa-fw fa-undo" />,
                label: t('ARCHIVED_PROJECTS:ProjectButtonRestore'),
                onClick: () => handleRestore(project._id),
              },
              {
                icon: <i className="fas fa-fw fa-trash-alt" />,
                label: t('ARCHIVED_PROJECTS:ProjectButtonDelete'),
                color: '#f44336',
                onClick: () => handleDelete(project._id),
              },
            ]}
            disabled
            onDisabledClick={() => {
              if (tooManyArchivedProjects) {
                showTooManyArchivedProjectsModal(t('HOME:TooManyArchivedProjects-title'))
              }
            }}
          />
        </Col>
      ))}
    </Row>
  )
}

export default ArchivedProjects
